<template>
	<div class="dataBoard">
		<div class="dataBoardTitle">
			<div class="dataBoardTitle-1">
				<span class="dataBoardTitle-1-circle"></span>
				<span class="dataBoardTitle-1-text"><img src="../../assets/tennis/WechatIMG797.png"/><span>五星网球分级电视挑战赛</span></span>
				<span class="dataBoardTitle-1-circle" @click="toPage"></span>
			</div>
		</div>
		<div class="score">
			<div class="countScore">
				<div class="countScore-m1">
					{{ scores[0].countscore }}
					<span>:</span>
					{{ scores[1].countscore }}
				</div>
			</div>
		</div>
		<div class="xuanshouBox">
			<div class="xuanshouBox-m1">
				<div class="xuanshouBox-m1-title">
					<img src="../../assets/tennis/icon1.png" alt="">
					<span class="text1">选手1:</span>
					<span class="text2" v-if="scores[0].name">{{ scores[0].name }}</span>
				</div>
				<div class="xuanshouBox-con">
					<div class="xuanshouBox-con-text1">{{ scores[0].score }}</div>
					<div class="xuanshouBox-con-text2"><img v-if="scores[0].serve == 1" src="../../assets/tennis/icon8.png" alt=""><span>score</span></div>
				</div>
			</div>
			<div class="xuanshouBox-m1">
				<div class="xuanshouBox-m1-title">
					<img src="../../assets/tennis/icon1.png" alt="">
					<span class="text1">选手2:</span>
					<span class="text2" v-if="scores[1].name">{{ scores[1].name }}</span>
				</div>
				<div class="xuanshouBox-con">
					<div class="xuanshouBox-con-text1">{{ scores[1].score }}</div>
					<div class="xuanshouBox-con-text2"><img v-if="scores[1].serve == 1" src="../../assets/tennis/icon8.png" alt=""><span>score</span></div>
				</div>
			</div>
			
		</div>
		<!-- <div class="score">
			<div class="countScore">
				<div class="countScore-m1">
					{{ scores[0].countscore }}
					<span>:</span>
					{{ scores[1].countscore }}
				</div>
			</div>
		</div> -->
		
		
	</div>
</template>

<script>
export default {
	name: 'databoard',
	data(){
		return {
			scores: [{
				name: '--',
				score: 0,
				countscore: 0
			},{
				name: '--',
				score: 0,
				countscore: 0
			}],
			timer: null,
		}
		
	},
	mounted() {
		this.matchid = this.$route.query.matchid
		this.trackid = this.$route.query.trackid
		var _this = this
		if(this.$route.query.groupnum){
			// console.log('opopo')
			this.getData();
			this.timer = setInterval(() => {
				_this.getData();
			}, 3000)
		}
		
	},
	beforeDestroy() {
		clearInterval(this.timer)
	},
	methods: {
		toPage(){
			console.log("999999")
			this.$router.push({
				name: 'setdashboard',
				query: {
					matchid: this.matchid,
					trackid: this.trackid,
					groupnum: '',
					isdashboard: 1,
				}
			})
		},
		getData(){
			let _this = this
			this.matchid = this.$route.query.matchid
			this.trackid = this.$route.query.trackid
			this.groupnum = this.$route.query.groupnum
			
			var data = {
				matchid: this.matchid,
				trackid: this.trackid,
				groupnum: this.groupnum
				// playid: this.playid
			}
			
			this.$api.tennis
				.getDataBoard(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						// scores: [{
						// 	name: '--',
						// 	score: 0,
						// 	countscore: 0
						// },{
						// 	name: '--',
						// 	score: 0,
						// 	countscore: 0
						// }]
						// _this.scores = []
						_this.$set(_this.scores[0], 'name', res.data[0].name)
						
						if(res.data[0].scores.length == 0){
							_this.$set(_this.scores[0], 'score', 0)
						}else{
							if(res.data[0].scores[(res.data[0].scores.length - 1)].score == 45){
								_this.$set(_this.scores[0], 'score', 40)
							}else{
								_this.$set(_this.scores[0], 'score', res.data[0].scores[(res.data[0].scores.length - 1)].score)
							}
						}
						// _this.$set(_this.scores[0], 'score', res.data[0].scores.length == 0 ? 0 : res.data[0].scores[(res.data[0].scores.length - 1)].score)
						_this.$set(_this.scores[0], 'serve', res.data[0].scores.length == 0 ? 0 : res.data[0].scores[(res.data[0].scores.length - 1)].serve)
						_this.$set(_this.scores[0], 'countscore', res.data[0].score)
						_this.$set(_this.scores[1], 'name', res.data[1].name)
						// _this.$set(_this.scores[1], 'score', res.data[1].scores.length == 0 ? 0 : res.data[1].scores[(res.data[1].scores.length - 1)].score)
						if(res.data[1].scores.length == 0){
							_this.$set(_this.scores[1], 'score', 0)
						}else{
							if(res.data[1].scores[(res.data[1].scores.length - 1)].score == 45){
								_this.$set(_this.scores[1], 'score', 40)
							}else{
								_this.$set(_this.scores[1], 'score', res.data[1].scores[(res.data[1].scores.length - 1)].score)
							}
						}
						
						_this.$set(_this.scores[1], 'serve', res.data[1].scores.length == 0 ? 0 : res.data[1].scores[(res.data[1].scores.length - 1)].serve)
						_this.$set(_this.scores[1], 'countscore', res.data[1].score)
						console.log("rrr", _this.scores)
					}
					// this.$toast.clear();
				});
		}
	}
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
